// extracted by mini-css-extract-plugin
export var alignCenter = "_70-d";
export var bannerShown = "_70-6";
export var buttonContent = "_70-0";
export var cardList = "_70-1";
export var centerContent = "_70-2";
export var chevron = "_70-3";
export var closePanelButton = "_70-k";
export var conversationContextContainer = "_70-l";
export var conversationDetailContainer = "_70-4";
export var detailWrapper = "_70-7";
export var dropdownButton = "_70-e";
export var dropdownTitle = "_70-9";
export var fullHeight = "_70-5";
export var hidden = "_70-a";
export var icon = "_70-b";
export var mergeSuggestionWrapper = "_70-m";
export var panel = "_70-i";
export var portalButtonsWrapper = "_70-c";
export var right = "_70-j";
export var tableSummaryContainer = "_70-8";
export var tableSummaryHeader = "_70-g";
export var threeDotsButton = "_70-f";
export var wide = "_70-h";